import {paymDocTableColumnLabels} from "@/features/i18n/paymDocTableColumns";

export interface PaymDocTableInterface {
    /** Z AutoTable – dopinane na froncie do każdego wiersza (kolumna „ID użytkownika”) */
    f_sales_user_name?: string;
    /** Numery procesu (do pola „Numer procesu” – zwykle takie same w każdym wierszu) */
    f_paym_ord_num?: string;
    f_paym_ord_user_name?: string;
    f_paym_ord_year?: string;
    f_paym_doc_c_who: string;
    f_paym_doc_c_typ_desc: string;
    f_paym_doc_num: string;
    f_paym_doc_dat: string;
    f_paym_doc_gross_mnt: number | null;
    f_paym_doc_comment: string;
}

export type PaymDocDataColumn = {
    accessorKey: keyof PaymDocTableInterface;
    header: string;
    size?: number;
};

export const paymDocColumns: PaymDocDataColumn[] = [
    {accessorKey: "f_sales_user_name", header: paymDocTableColumnLabels.f_sales_user_name, size: 120},
    {accessorKey: "f_paym_doc_c_who", header: paymDocTableColumnLabels.f_paym_doc_c_who, size: 120},
    {accessorKey: "f_paym_doc_c_typ_desc", header: paymDocTableColumnLabels.f_paym_doc_c_typ_desc, size: 140},
    {accessorKey: "f_paym_doc_num", header: paymDocTableColumnLabels.f_paym_doc_num, size: 120},
    {accessorKey: "f_paym_doc_dat", header: paymDocTableColumnLabels.f_paym_doc_dat, size: 110},
    {accessorKey: "f_paym_doc_gross_mnt", header: paymDocTableColumnLabels.f_paym_doc_gross_mnt, size: 130},
    {accessorKey: "f_paym_doc_comment", header: paymDocTableColumnLabels.f_paym_doc_comment, size: 200},
];
